<footer class="customer-footer" *appHasRole="['user']">
  <div class="customer-footer__container" >

    <div class="customer-footer__col brand">
      <span class="title">M4N - Matched Trading</span>
      <span class="subtitle"> <!--
        Piattaforma di matched betting per utenti retail. -->
      </span>
    </div>

    <div class="customer-footer__col links">
       <!--
      <span class="section">Supporto</span>
      <a routerLink="/support">Centro Assistenza</a>
      <a routerLink="/faq">FAQ</a>
      <a routerLink="/contact">Contattaci</a>
      -->
    </div>

    <div class="customer-footer__col links">
      <!--
      
      <span class="section">Legale</span>
      <a routerLink="/privacy">Privacy Policy</a>
      <a routerLink="/terms">Termini di Servizio</a>
      <a routerLink="/cookies">Cookie Policy</a>
      -->
    </div>

  </div>

  <div class="customer-footer__bottom">
    © {{ currentYear }} Matched Trading — Tutti i diritti riservati
  </div>
</footer>
